import { createElement } from 'react'
import { InWinImage } from 'routes/shared/components'
import controlTeamAthletes from './components/controls'

function createInWinImage({ value }) {
  return createElement(InWinImage, { source: value, alt: value })
}

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Surname',
    accessor: 'surname',
  },
  {
    Header: 'Nationality',
    accessor: 'nationality',
  },
  {
    Header: 'Sport',
    accessor: 'sport',
  },
  {
    Header: 'Date Of Birth',
    accessor: 'dateOfBirth',
  },
  {
    Header: 'Add to team',
    id: 'controls',
    maxWidth: 500,
    accessor: (value) => value,
    Cell: controlTeamAthletes,
  },
]
